export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative group">
            <img
              src="https://images.pexels.com/photos/2800832/pexels-photo-2800832.jpeg?auto=compress&cs=tinysrgb&w=800"
              alt="Solar installation"
              className="rounded-lg shadow-2xl w-full h-[500px] object-cover group-hover:scale-[1.02] transition-transform duration-500"
            />
          </div>

          <div>
            <div className="text-orange-500 text-sm font-semibold mb-3 tracking-wider">ABOUT US</div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Among The Top 10 Solar & Renewable Energy Industry
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              Clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo et amet, tempor amet diam magna labore et ullamco justo erat tempor labore dolor sit lorem
            </p>
            <p className="text-gray-600 leading-relaxed mb-8">
              Aliqip diam amet amet eos eos clita erat ipsum et lorem et sit, sed stet lorem sit clita duo justo et amet
            </p>
            <button className="px-8 py-4 bg-orange-500 text-white rounded-full font-medium hover:bg-orange-600 transition-all duration-300 hover:shadow-xl hover:scale-105">
              Find Out More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
